import React, { useContext, useEffect, useState } from "react";
import styles from "./CustomPopUp.module.css";
import {
  Button,
  CircularProgress,
  Dialog,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DateField from "../DateField/DateField";
import { threeYearsBack, YYMMDD } from "../../Pages/Consumption/utility/utils";
import { getApi, PatchApi, PostApi } from "../../Utility/network";
import { stringToYYYYMMDD } from "../../Utility/helper";
import { useLocation } from "react-router-dom";
import { AppContext } from "../../ContextApi/AppContext/AppContext";
import { consumptionEngText, consumptionGermText } from "../Pannel/Pannel";
function CustomPopUp({ open, handleClose, data }) {
  const { state, setState, showSnackbar } = useContext(AppContext);
  const { stepLanguage, language } = state;
  const [formData, setFormData] = useState({
    company: "",
    tracking_no: null,
    shipping_date: new Date(),
  });
  const location = useLocation();
  const [companies, setCompanies] = useState([]);
  const [loader, setLoader] = useState(false);
  const [visible, setVisible] = useState(true);
  const handleChangeINput = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const getCompanies = async () => {
    try {
      const response = await getApi(
        `/energy_consumption/courier_company_listing`
      );
      setCompanies(response?.data?.data);
    } catch (error) {}
  };
  const handleDelivery = async (id) => {
    const courier_service = {
      courier_service: {
        company_id: formData?.company,
        tracking_id: formData?.tracking_no,
        date_of_dispatch: stringToYYYYMMDD(formData?.shipping_date),
      },
    };
    const url = location?.pathname.includes("energy-certificate")
      ? `/energy_need/${id}/`
      : `/energy_consumption/form/${id}/`;
    try {
      const response = await PatchApi(url, courier_service);
      showSnackbar("Daten erfolgreich speichern");
      setVisible(false);
    } catch (error) {}
  };
  useEffect(() => {
    getCompanies();
  }, []);
  const energy_consumption = { energy_consumption: data?.id };
  const energy_need = { energy_need: data?.id };

  const sendMail = async () => {
    setLoader(true);

    const data =
      location?.pathname == "/energy-certificate"
        ? energy_need
        : energy_consumption;

    try {
      const response = await PostApi(
        `/payment/create/send_shipping_email/`,
        data
      );
      setLoader(false);
      showSnackbar("E-Mail erfolgreich gesendet");
    } catch (error) {}
  };
  return (
    <Dialog onClose={handleClose} open={open}>
      <div className={styles.con}>
        <div className={styles.datas}>
          <p 
            className={styles.nameHead}
            style={{ textTransform: language === "en" ? "none" : "capitalize" }}
          >
            {data?.id} | {data?.billing_address?.first_name}{" "}
            {data?.billing_address?.last_name}
          </p>

          <div
            style={{ textAlign: "end", cursor: "pointer" }}
            onClick={handleClose}
          >
            <CloseIcon color="success" />
          </div>
        </div>

        <div className={styles.FieldCon}>
          <p className={styles.name}>
            {" "}
            {language == "de"
              ? consumptionGermText?.shipping_company
              : consumptionEngText?.shipping_company}
          </p>
          {/* <TextField
            size="small"
            value={formData?.company}
            onChange={(e) => handleChangeINput(e)}
            name="company"
            //   error={percentageError}
            //   helperText={percentageError}
          /> */}
          <Select
            sx={{ width: "100%" }}
            size="small"
            value={formData?.company}
            name="company"
            onChange={(e) => {
              handleChangeINput(e);
            }}
          >
            {companies?.map((option) => (
              <MenuItem key={option.id} value={option.id}>
                {option.title}
              </MenuItem>
            ))}
          </Select>
        </div>
        <div className={styles.FieldCon}>
          <p className={styles.name}>
            {" "}
            {language == "de"
              ? consumptionGermText?.tracking_no
              : consumptionEngText?.tracking_no}
          </p>

          <TextField
            size="small"
            value={formData?.tracking_no}
            onChange={(e) => handleChangeINput(e)}
            name="tracking_no"
            sx={{ width: "100%" }}

            //   error={percentageError}
            //   helperText={percentageError}
          />
        </div>
        <div className={styles.FieldCon}>
          <p className={styles.name}>
            {language == "de"
              ? consumptionGermText?.dispatch
              : consumptionEngText?.dispatch}
          </p>
          <DateField
            onChange={(date) =>
              setFormData((prev) => ({ ...prev, shipping_date: date }))
            }
            startDate={formData?.shipping_date}
            style={{ width: "100%" }}
            max={true}
            minDate={threeYearsBack(3)}
          />
        </div>
        <div className={styles.SmallFieldcon}>
          <div className={styles?.button}>
            <Button
              sx={{
                background: "linear-gradient(90deg, #22A156 0%, #AFDB28 100%)",
                padding: "10px 20px",
                color: "white",
              }}
              variant="contained"
              onClick={() => {
                handleDelivery(data?.id);
                // handleClose();
              }}
            >
              {language == "de"
                ? consumptionGermText?.save
                : consumptionEngText?.save}
            </Button>
          </div>

          <div className={styles?.button}>
            <Button
              sx={{
                background: "linear-gradient(90deg, #22A156 0%, #AFDB28 100%)",
                padding: "10px 20px",
                color: "white",
                "&:disabled": {
                  background: "gray",
                  color: "#ccc",
                },
              }}
              variant="contained"
              onClick={() => sendMail()}
              disabled={visible || loader}
            >
              {language == "de"
                ? consumptionGermText?.send_email_order
                : consumptionEngText?.send_email_order}
              {loader && <CircularProgress size={25} color="success" />}
            </Button>
          </div>
        </div>
      </div>
    </Dialog>
  );
}

export default CustomPopUp;
